import {parseSearchString} from '../../../utils/convertation/parseSearchString';
import {spaceNumber} from '../../../utils/numerals/spaceNumber'; 
import {stringifySearchParameters} from '../../../utils/convertation/stringifySearchParameters';
import {pluralNumber} from '../../../utils/numerals/pluralNumber';

export const initVisualChooser = ( chooser ) => {
	const floorsList = chooser.querySelector( 'ul.floors' );
	const backButton = chooser.querySelector( 'form.chooser-form button.back' );
	const scheme = chooser.querySelector( 'form.chooser-form div.scheme svg' );
	const view = chooser.querySelector( 'div.bird > figure' );
	const tooltip = chooser.querySelector( 'div.tooltip' );
	const tip = chooser.querySelector( 'div.tip' );
	const componentID = chooser.id;
	const searchParameters = parseSearchString( location.search );
	const fullSearchParameters = Object.assign( {}, searchParameters );
	let chooserData, schemeRevised, tooltipRect;

	const changeProperty = ( object, property, value ) => {
		if ( value )
		{
			object[property] = value
		}
		else
		{
			delete object[property];
		}
	};

	const disableApartments = () => {
		const viewRect = view.getBoundingClientRect();

		Array.from( view.querySelectorAll( 'span' ) ).forEach( ( it ) => {
			it.remove();
		} );
		
		Array.from( view.querySelectorAll( '[id*="APT-"]' ) ).forEach( ( it ) => {
			const apartmentID = `${it.id.replace( 'APT-', '' )}-${searchParameters.building}`;

			if ( chooserData.roomsData.rooms.find( ( room ) => room.id === apartmentID ) )
			{
				if ( chooserData.roomsData.rooms.find( ( room ) => room.id === apartmentID ).enums.state )
				{
					it.classList.add( 'booked' );

					const apartmentRect = it.getBoundingClientRect();
					const lock = document.createElement( 'span' );

					lock.style.top = `${apartmentRect.y + ( apartmentRect.height / 2 ) - viewRect.y}px`;
					lock.style.left = `${apartmentRect.x + ( apartmentRect.width / 2 ) - viewRect.x}px`;
					view.append( lock );
				}
				
				it.dataset.available = 'yes';
			}
			else
			{
				it.removeAttribute( 'data-available' );
			}
		} );
	}

	const getData = ( url ) => {
		window.fetch( url, {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		} )
			.then( ( response ) => response.json() )
			.then( ( msg ) => {
				chooserData = msg;

				Array.from( scheme.querySelectorAll( 'g[id*="BLD-"]' ) ).forEach( ( it ) => {
					const buildingNumber = it.id.replace( 'BLD-', '' );

					if ( !chooserData.controls.buildings.available.find( ( building ) => building.alias === buildingNumber ) )
					{
						it.id = it.id.replace( 'BLD-', 'BLDDIS-' );
					}
				} );
				
				if ( searchParameters.floor )
				{
					showFloor();
				}
				else
				{
					showComplex();
				}
			} );
	};

	const handleApartment = ( evt ) => {
		const apartment = evt.target.closest( '[id*="APT-"]' );
		const apartmentID = `${apartment.id.replace( 'APT-', '' )}-${searchParameters.building}`;
		const apartmentData = chooserData.roomsData.rooms.find( ( room ) => room.id === apartmentID );

		tooltip.querySelector( 'h3' ).innerHTML = `${String( apartmentData.layout.areas.main.value ).replace( '.', ',' )} м²`;
		tooltip.querySelector( 'ul' ).innerHTML = `<li>№ ${apartment.id.replace( 'APT-', '' )}</li><li>Дом ${searchParameters.building}</li><li>${apartmentData.layout.properties.rooms_count.value}-комн.</li>`;
		tooltip.querySelector( 'p.price' ).innerHTML = `${spaceNumber( apartmentData.prices.full.value )} ₽`;
		tooltip.dataset.apartment = apartmentID;
		moveTooltip( evt );
		tooltip.classList.add( 'show' );
	};

	const handleBuilding = ( evt, id ) => {
		if ( window.innerWidth < 1024 && view.querySelector( 'g.hover' ) )
		{
			view.querySelector( 'g.hover' ).classList.remove( 'hover' );
			chooser.querySelector( `ul.labels > li[data-id].hover` ).classList.remove( 'hover' );
		}
		
		let building = evt.target?.closest( '[id*="BLD-"]' );

		if ( !building ) {
			building = view.querySelector( `[id*="BLD-${id}"]` );
		}

		const buildingID = building.id.replace( 'BLD-', '' );

		building.classList.add( 'hover' );
		chooser.querySelector( `ul.labels > li[data-id="${buildingID}"]` ).classList.add( 'hover' );
		tooltip.querySelector( 'h3' ).innerHTML = building.dataset.building;
		tooltip.querySelector( 'ul' ).innerHTML = `<li>${building.dataset.deadline}</li><li>${building.dataset.count} в продаже</li>`;
		tooltip.querySelector( 'p.price' ).innerHTML = building.dataset.minPrice;
		tooltip.dataset.building = buildingID;
		moveTooltip( evt )
		tooltip.classList.add( 'show' );
	};
	
	const handleResize = () => {
		if ( window.innerWidth < 1024 && window.innerHeight > window.innerWidth )
		{
			tip.classList.remove( 'hide' );
		}
		else
		{
			tip.classList.add( 'hide' );
		}
		
		if ( view.querySelector( 'g.hover' ) )
		{
			view.querySelector( 'g.hover' ).classList.remove( 'hover' );
			chooser.querySelector( `ul.labels > li[data-id].hover` ).classList.remove( 'hover' );
		}

		tooltip.classList.remove( 'show' );

		if ( !chooser.classList.contains( 'floor' ) )
		{
			placeLabels();
		}
		else
		{
			disableApartments();
		}
	};

	const hideTooltip = () => {
		if ( window.innerWidth < 1024 )
		{
			return;
		}

		if ( view.querySelector( 'g.hover' ) )
		{
			view.querySelector( 'g.hover' ).classList.remove( 'hover' );
			chooser.querySelector( `ul.labels > li[data-id].hover` ).classList.remove( 'hover' );
		}
		
		tooltip.classList.remove( 'show' );
	};

	const highlightApartment = ( evt ) => {
		if ( window.innerWidth < 1024 )
		{
			return;
		}
		
		handleApartment( evt );
	};

	const highlightBuilding = ( evt ) => {
		if ( window.innerWidth < 1024 )
		{
			return;
		}
		
		handleBuilding( evt );
	};

	const moveTooltip = ( evt ) => {
		if ( window.innerWidth < 1024 )
		{
			tooltip.style.top = '';
			tooltip.style.bottom = '';
			tooltip.style.left = '';
		}
		else
		{
			tooltipRect = tooltip.getBoundingClientRect();

			if ( tooltipRect.height + 24 > window.innerHeight - evt.pageY )
			{
				tooltip.classList.add( 'to-top' );
			}
			else
			{
				tooltip.classList.remove( 'to-top' );
			}

			tooltip.style.top = `${evt.pageY - ( window.pageYOffset + chooser.getBoundingClientRect().y )}px`;
			tooltip.style.left = `${evt.pageX}px`;
		}
	};

	const placeLabels = () => {
		if ( chooser.classList.contains( 'floor' ) )
		{
			return;
		}
		
		Array.from( view.querySelectorAll( 'ul.labels > li[data-id]' ) ).forEach( ( it ) => {
			it.classList.remove( 'show' );
		} );
		
		Array.from( view.querySelectorAll( 'circle' ) ).forEach( ( it ) => {
			const buildingID = it.id.replace( 'LBL-', '' );
			const x = Math.round( it.getBoundingClientRect().left - chooser.getBoundingClientRect().left + it.getBoundingClientRect().width / 2 );
			const y = Math.round( it.getBoundingClientRect().top - chooser.getBoundingClientRect().top + it.getBoundingClientRect().height / 2 );
			let label = chooser.querySelector( `li[data-id="${buildingID}"]` );

			if ( !label )
			{
				label = document.createElement( 'li' );
				label.dataset.id = buildingID;
				label.innerHTML = buildingID;
				view.querySelector( 'ul.labels' ).append( label );
			}

			label.style.top = `${y}px`;
			label.style.left = `${x}px`;
			label.classList.add( 'show' );

			const building = view.querySelector( `[id="BLD-${buildingID}"]` );

			if ( !building || building.classList.contains( 'disabled' ) )
			{
				label.classList.add( 'disabled' );
			}
		} );
	};

	const rearrangeCurrent = ( parent, selector ) => {
		if ( parent.querySelector( '.current' ) )
		{
			parent.querySelector( '.current' ).classList.remove( 'current' );
		}

		parent.querySelector( selector ).classList.add( 'current' );
	};

	const requestData = ( building, floor ) => {
		changeProperty( searchParameters, 'building', building );
		changeProperty( fullSearchParameters, 'building', building );
		changeProperty( searchParameters, 'floor', floor );
		changeProperty( fullSearchParameters, 'floor', floor );
		window.history.pushState( {}, document.querySelector( 'head title' ).innerHTML, location.pathname + stringifySearchParameters( searchParameters ) );
		getData( location.pathname + stringifySearchParameters( fullSearchParameters ) );
	};

	const selectApartment = ( evt ) => {
		if ( window.innerWidth < 1024 )
		{
			handleApartment( evt );

			return;
		}

		const apartment = evt.target.closest( '[id*="APT-"]' );
		const apartmentID = `${apartment.id.replace( 'APT-', '' )}-${searchParameters.building}`;

		location.href = `${location.pathname}${apartmentID}/`;
	};
	
	const selectBuilding = ( evt, id ) => {
		if ( window.innerWidth < 1024 )
		{
			handleBuilding( evt, id );

			return;
		}

		let buildingID;
		
		if ( !id ) {
			const building = evt.target.closest( '[id*="BLD-"]' );
			buildingID = building.id.replace( 'BLD-', '' );
		} else {
			buildingID = id;
		}

		requestData( buildingID, 1 );
	};

	const showComplex = () => {
		chooser.classList.remove( 'floor' );
		tooltip.classList.remove( 'show' );
		tooltip.removeAttribute( 'data-apartment' );
		chooser.querySelector( 'h1' ).innerHTML = 'Выбрать квартиру';

		if ( view.querySelector( 'svg' ) )
		{
			view.querySelector( 'svg' ).remove();
		}

		if ( chooser.querySelector( `ul.labels > li[data-id].hover` ) )
		{
			chooser.querySelector( `ul.labels > li[data-id].hover` ).classList.remove( 'hover' );
		}

		view.insertAdjacentHTML( 'afterbegin', chooserData.complex_rendered );
		handleResize();

		Array.from( view.querySelectorAll( 'ul.labels li:not(.disabled)' ) ).forEach( ( it ) => {
			
			it.addEventListener( 'mouseenter', (evt) => {
				if ( window.innerWidth < 1024 )
				{
					return;
				}
				
				handleBuilding( evt, it.dataset.id );
			});

			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', (evt) => {
				selectBuilding(evt, it.dataset.id);
			});
			
		} );
		
		Array.from( view.querySelectorAll( '[id*="BLD-"]' ) ).forEach( ( it ) => {
			it.addEventListener( 'mouseenter', highlightBuilding );
			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', selectBuilding );
		} );
	};

	const showFloor = () => {
		chooser.classList.add( 'floor' );
		tooltip.classList.remove( 'show' );
		tooltip.removeAttribute( 'data-building' );
		chooser.querySelector( 'h1' ).innerHTML = `Дом ${searchParameters.building}`;
		const buildingRoomsCount = Object.values(chooserData.building_data).reduce( (acc, floor) => acc += floor.rooms_count, 0);

		chooser.querySelector( 'p.count' ).innerHTML = buildingRoomsCount ? `${pluralNumber( buildingRoomsCount, 'квартира', 'квартиры', 'квартир' )} в продаже` : 'квартир в продаже нет';

		if ( view.querySelector( 'svg' ) )
		{
			view.querySelector( 'svg' ).remove();
		}

		view.insertAdjacentHTML( 'afterbegin', chooserData.floor_data.rendered );
		rearrangeCurrent( floorsList, `li[data-floor="${searchParameters.floor}"]` );
		rearrangeCurrent( scheme, `g#BLD-${searchParameters.building}` );
		disableApartments();
		handleResize();
		
		Array.from( view.querySelectorAll( '[id*="APT-"]:not( [data-disabled] )' ) ).forEach( ( it ) => {
			it.addEventListener( 'mouseenter', highlightApartment );
			it.addEventListener( 'mousemove', moveTooltip );
			it.addEventListener( 'mouseleave', hideTooltip );
			it.addEventListener( 'click', selectApartment );
		} );
	};

	fullSearchParameters['ajax_component'] = componentID;
	getData( location.pathname + stringifySearchParameters( fullSearchParameters ) );
	window.addEventListener( 'resize', handleResize );

	backButton.addEventListener( 'click', () => {
		requestData( false, false );
	} );

	floorsList.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.dataset.floor )
		{
			return;
		}

		const requestedFloor = evt.target.dataset.floor;

		requestData( searchParameters.building, requestedFloor );
	} );

	scheme.addEventListener( 'click', ( evt ) => {
		if ( !evt.target.closest( '[id*="BLD-"]' ) )
		{
			return;
		}

		const requestedBuilding = evt.target.closest( '[id*="BLD-"]' ).id.replace( 'BLD-', '' );

		requestData( requestedBuilding, 1 );
	} );

	tooltip.addEventListener( 'click', () => {
		const building = tooltip.dataset.building;
		const apartment = tooltip.dataset.apartment;

		if ( apartment )
		{
			location.href = `${location.pathname}${apartment}/`;
		}
		else if ( building )
		{
			requestData( building, 1 );
		}
	} );

	chooser.addEventListener( 'click', ( evt ) => {
		if ( evt.target.closest( 'li.show' ) || evt.target.closest( '[id*="BLD-"]' ) || evt.target.closest( '[id*="APT-"]' ) || evt.target.closest( 'div.tooltip' ) || window.innerWidth > 1023 || !tooltip.classList.contains( 'show' ) )
		{
			return;
		}

		if ( view.querySelector( 'g.hover' ) )
		{
			view.querySelector( 'g.hover' ).classList.remove( 'hover' );
			chooser.querySelector( `ul.labels > li[data-id].hover` ).classList.remove( 'hover' );
		}

		tooltip.classList.remove( 'show' );
	} );
};
